export default __webpack_public_path__ + "static/media/sister-sanantonio.7775efc8.png";